import cloneDeep from "lodash/cloneDeep";

import { ActionTree, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import { fetchEnumsFromSchema } from "@/core/tools/forms/fetch_enums_from_schema";
import { generateFormObject } from "@/core/tools/forms/generate_form_object";
import { prepareFormObjectForSave } from "@/core/tools/forms/prepare_form_object_for_save";
import moment from "moment";

interface PrimeCostCopyFormState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;

  form: any;
}

const state: PrimeCostCopyFormState = {
  loading: false,
  loaded: true,
  fatalError: false,

  form: {
    from: null,
    to: null,
  },
};

const initState: PrimeCostCopyFormState = cloneDeep(state);

export const PRODUCT_DATA = "GET_PRODUCT_DATA";
export const PRODUCT_SCHEMA = "GET_PRODUCT_SCHEMA";

export const actions: ActionTree<PrimeCostCopyFormState, RootState> = {
  changeValue({ commit }, { field, value }) {
    commit("CHANGE_VALUE", { field, value });
  },

  saveForm({ commit, state }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      commit("START_LOADING");
      vm.$http
        .post(`/api/v1/prime_costs/copy`, state.form, {})
        .then((response: any) => {
          commit("LOADED_SUCCESS");
          resolve(null);
        });
    });
  },
};

export const mutations: MutationTree<PrimeCostCopyFormState> = {
  RESET_STATE: (state) => {
    for (const key in initState) {
      (state as any)[key] = (initState as any)[key];
    }
  },

  START_LOADING: (state) => {
    state.loaded = false;
    state.loading = true;
    state.fatalError = false;
  },

  LOADED_SUCCESS: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = false;
  },

  LOADED_ERROR: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = true;
  },

  CHANGE_VALUE(state, { field, value }) {
    state.form[field] = moment(value).format("YYYY-MM-DD");
  },
};

const getters = {};

export const STORE_KEY = "$_prime_costs_list_prime_cost_copy_form";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
